import { render } from "./CarBrandsModels.vue?vue&type=template&id=39b79c2d&scoped=true"
import script from "./CarBrandsModels.vue?vue&type=script&lang=js"
export * from "./CarBrandsModels.vue?vue&type=script&lang=js"

import "./CarBrandsModels.vue?vue&type=style&index=0&id=39b79c2d&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-39b79c2d"

export default script